import { AxiosResponse } from 'axios';

import {
  UserPreviewData,
  Testimonial,
  CaseStudy,
  Course,
  Certificate,
  Test,
  CustomCertificate,
  ChatUser,
} from '../../types';

export enum Statuses {
  indefinite = 'Indefinite',
  limited = 'Limited',
  no_rtw = 'Unverified',
}

type ShortQualificationProps = {
  verified?: boolean;
  isHiring?: boolean;
  show_status: boolean;
};

export type QualificationType =
  | (Course & ShortQualificationProps & { type: 'course' })
  | (Certificate &
      ShortQualificationProps & { type: 'certificate'; reference_number: string; verified: boolean })
  | (Test & ShortQualificationProps & { type: 'test' });

export interface WorkExperienceDTO {
  title: string;
  start_date: string;
  end_date: string;
  currently_active: boolean;
  company: {
    name: string;
  };
  isHiring?: boolean;
}

export interface QualificationDTO {
  title: string;
  crt_type: string;
  issuer: string;
  start_date: string;
  expiry_date: string;
  source: string;
  uuid: string;
  isHiring?: boolean;
}

export type SetNotification = (args0: Notification) => void;
export type ShowHealthAndSafetyPDFRequest = (args0: {
  userId: string;
  companyId?: string;
}) => Promise<AxiosResponse<any>>;

export interface UserPreviewProps {
  userPreviewData: UserPreviewData;
  goToEditView?: Function;
  paymentsLink?: string;
  agreementsLink?: string;
  timesheetsLink?: string;
  userId?: string;
  rtw?: any;
  passport?: any;
  companyId?: string;
  hasPermissionsToEditAgencyData?: boolean;
  showHealthAndSafetyPDFRequest?: ShowHealthAndSafetyPDFRequest;
  deleteCustomQualificationRequest?: (
    certificateId: string,
    userId: string
  ) => Promise<AxiosResponse<string>>;
  hasPermissionForCreateQualification?: boolean;
  withAddQualificationModal?: boolean;
  isLegend?: boolean;
  isShowAgencyData?: boolean;
  hideListedQualificationRequest?: (qualificationId: string) => void;
  renderQualificationModal?: ({
    isOpen,
    selectedQualification,
    onClose,
  }: {
    isOpen: boolean;
    selectedQualification: CustomCertificate;
    onClose: () => void;
  }) => React.ReactNode;
  createPrivateChat?: () => Promise<void>;
}

export type ExpandableViewItem = WorkExperienceDTO | QualificationType | Testimonial | CaseStudy;
